<div class="p-4 max-w-3xl mx-auto">
  <h2 class="text-2xl font-bold mb-6">
    {{ isEditMode ? ('::EditWinery' | abpLocalization) : ('::NewWinery' | abpLocalization) }}
  </h2>

  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col gap-2">
     <app-metro-upload-images
      [initialImageUrl]="imagePreviewUrl"
      (imageSelected)="onImageSelected($event)">
    </app-metro-upload-images>

    <!-- Nombre -->
    <app-metro-form-input label='{{"::Name" | abpLocalization}}' formControlName="name"
      [placeholder]='"::Name" | abpLocalization' size="md" type="text">
    </app-metro-form-input>

    <!-- País -->
    <app-metro-form-select label='{{"::Country" | abpLocalization}}' [options]="countryOptions"
      formControlName="country" (selectionChange)="onCountryChange($event)" [size]="'md'">
    </app-metro-form-select>

    <!-- Región -->
    <!-- Texto libre (winepassport#344): antes era un select alimentado por un JSON curado
         de países→regiones, incompleto y sin poder escribir la región real de cada bodega. -->
    <app-metro-form-input label='{{"::Region" | abpLocalization}}' formControlName="region"
      [placeholder]='"::Region" | abpLocalization' size="md" type="text">
    </app-metro-form-input>

    <!-- Subregión -->
    <app-metro-form-input label='{{"::Subregion" | abpLocalization}}' formControlName="subregion"
      [placeholder]='"::Subregion" | abpLocalization' size="md" type="text">
    </app-metro-form-input>

    <!-- Descripción corta (tarjeta de la landing) -->
    <app-metro-form-input label='{{"::ShortDescription" | abpLocalization}}' formControlName="shortDescription"
      [placeholder]='"::ShortDescription" | abpLocalization' size="md" type="text">
    </app-metro-form-input>

    <!-- Descripción larga (editorial del modal) — winepassport#376: textarea para poder
         separar párrafos con línea en blanco (el modal de la landing los renderiza como <p>). -->
    <app-metro-form-textarea label='{{"::Description" | abpLocalization}}' formControlName="description"
      [placeholder]='"::Description" | abpLocalization' [rows]="3" minHeightClass="min-h-20">
    </app-metro-form-textarea>

    <!-- Dirección -->
    <app-metro-form-input label='{{"::Address" | abpLocalization}}' formControlName="address"
      [placeholder]='"::Address" | abpLocalization' size="md" type="text">
    </app-metro-form-input>

    <!-- Link de Google Maps (winepassport#377) — se usa en "Ver en Google Maps" del modal de la landing -->
    <app-metro-form-input label='{{"::GoogleMapsLink" | abpLocalization}}' formControlName="googleMapsUrl"
      [placeholder]='"::GoogleMapsLinkPlaceholder" | abpLocalization' size="md" type="text">
    </app-metro-form-input>

    <!-- Contacto -->
    <app-metro-form-input label='{{"::Contact" | abpLocalization}}' formControlName="contactName"
      [placeholder]='"::Contact" | abpLocalization' size="md" type="text">
    </app-metro-form-input>

    <!-- Email -->
    <app-metro-form-input label='{{"::Email" | abpLocalization}}' formControlName="email"
      [placeholder]='"::Email" | abpLocalization' size="md" type="email">
    </app-metro-form-input>

    <!-- Teléfono -->
    <app-metro-form-input label='{{"::Phone" | abpLocalization}}' formControlName="phone"
      [placeholder]='"::Phone" | abpLocalization' size="md" type="text">
    </app-metro-form-input>

    <!-- Sitio web -->
    <app-metro-form-input label='{{"::Website" | abpLocalization}}' formControlName="website"
      [placeholder]='"::Website" | abpLocalization' size="md" type="text">
    </app-metro-form-input>

    <!-- Galería secundaria (modal de la landing) — máx. 3 -->
    <div class="mt-2">
      <label class="block text-sm font-medium mb-1">
        {{ "::WineryGallery" | abpLocalization }} ({{ gallery.length }}/{{ maxGallery }})
      </label>

      <app-metro-upload-images *ngIf="gallery.length < maxGallery"
        [multiple]="true"
        (imageSelected)="onGallerySelected($event)">
      </app-metro-upload-images>

      <div *ngIf="gallery.length" class="flex flex-wrap gap-3 mt-3">
        <div *ngFor="let item of gallery; let i = index"
          class="relative w-28 h-28 rounded-md overflow-hidden border border-gray-200 bg-gray-50">
          <img *ngIf="item.previewUrl" [src]="item.previewUrl" alt="" class="w-full h-full object-cover" />
          <button type="button" (click)="removeGalleryItem(i)"
            class="absolute top-1 right-1 bg-black/60 text-white rounded-full w-5 h-5 leading-5 text-xs">×</button>
          <div class="absolute bottom-1 right-1 flex gap-1">
            <button type="button" (click)="moveGalleryItem(i, -1)" [disabled]="i === 0"
              class="bg-black/60 text-white rounded w-5 h-5 leading-5 text-xs disabled:opacity-30">↑</button>
            <button type="button" (click)="moveGalleryItem(i, 1)" [disabled]="i === gallery.length - 1"
              class="bg-black/60 text-white rounded w-5 h-5 leading-5 text-xs disabled:opacity-30">↓</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Botón guardar -->
    <div class="flex justify-end pt-4">
      <app-metro-button variant="primary"
        text="{{ isEditMode ? ('::SaveChanges' | abpLocalization) : ('::AddWinery' | abpLocalization) }}" type="submit">
      </app-metro-button>
    </div>
  </form>
</div>
